import { format, formatDistance, isToday, isYesterday } from "date-fns";

export const getDateDistance = (date) => {
  if (!date) return "";
  return formatDistance(date, new Date(), { addSuffix: true });
};

export function formatMessageDate(date) {
  try {
    if (!date) return "";

    const dateObj = new Date(date);

    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
      return "";
    }

    if (isToday(dateObj)) {
      // Today: hh:mm
      return format(dateObj, "HH:mm");
    } else if (isYesterday(dateObj)) {
      // Yesterday: Yesterday hh:mm
      return `Yesterday ${format(dateObj, "HH:mm")}`;
    } else {
      const isThisYear = dateObj.getFullYear() === new Date().getFullYear();
      // Other: dd/MM/yyyy hh:mm
      // return format(dateObj, "dd/MM/yyyy HH:mm");
      return isThisYear
        ? format(dateObj, "MMM d, HH:mm") // Feb 1, 00:00
        : format(dateObj, "dd/MM/yy"); // 01/02/24
    }
  } catch (error) {
    console.error("Error formatting message date:", error);
    return "";
  }
}

export const formatMessageTime = (date) => {
  if (!date) return "";
  try {
    const dateObj = new Date(date);
    return isNaN(dateObj.getTime()) ? "" : format(dateObj, "h:mm a");
  } catch {
    return "";
  }
};

export const formatDayHeader = (date) => {
  if (!date) return "";
  try {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return "";

    if (isToday(dateObj)) return "Today";
    if (isYesterday(dateObj)) return "Yesterday";

    const currentYear = new Date().getFullYear();
    const messageYear = dateObj.getFullYear();
    return messageYear === currentYear
      ? format(dateObj, "EEE, MMM d")
      : format(dateObj, "EEE, MMM d, yyyy");
  } catch {
    return "";
  }
};

const getMonthName = (month) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthNames[month];
};

const getDate = (date) => {
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = getMonthName(dateObj.getMonth());
  return `${month} ${year}`;
};

export default getDate;
